import React from "react";

const Topbar = () => {
  return (
    <div className="flex justify-between items-center bg-white shadow px-6 py-4">
      <h2 className="text-xl font-semibold text-gray-800">
        Admin Dashboard
      </h2>

      <div className="flex items-center gap-4">
        <div className="text-sm text-gray-600">
          Welcome Admin 👋
        </div>

        <img
          src="https://i.pravatar.cc/40"
          alt="admin"
          className="w-10 h-10 rounded-full"
        />
      </div>
    </div>
  );
};

export default Topbar;